import React from 'react';

import Input from 'antd/es/input';
import Switch from 'antd/es/switch';
import Form from 'antd/es/form';

import { featureToggleType } from 'config/featureToggles';

import Select from 'components/Select';

const attributeOptions = [
  {
    label: 'Visible',
    value: featureToggleType.VISIBLE,
  },
  {
    label: 'Disabled',
    value: featureToggleType.DISABLED,
  },
  {
    label: 'Variant',
    value: featureToggleType.VARIANT,
  },
];

const FeatureFlagForm = ({ form, locationOptions = [] }) => {

  return (
    <Form
      form={form}
      layout="vertical"
      hideRequiredMark={true}
      onFinish={form.onSubmit}
    >
      <Form.Item
        label="Name"
        name="config_name"
        rules={[
          {
            required: true,
            message: 'Feature flag name is required',
          },
        ]}
      >
        <Input placeholder="Enter name" />
      </Form.Item>

      <Form.Item
        label="Attribute"
        name="attribute"
        initialValue={attributeOptions[0].value}
        rules={[
          {
            required: true,
            message: 'Attribute is required',
          },
        ]}
      >
        <Select options={attributeOptions} placeholder="Select Attribute" />
      </Form.Item>

      <Form.Item
        label="Location"
        name="location_id"
        rules={[
          {
            required: true,
            message: 'Location is required'
          }
        ]}
      >
        <Select options={locationOptions} placeholder="Select Location" />
      </Form.Item>

      <Form.Item shouldUpdate>
        {({ getFieldValue }) => {
          const selectedAttribute = getFieldValue('attribute');
          return selectedAttribute === featureToggleType.VARIANT ? (
            <Form.Item
              label="Variant"
              name="val"
            >
              <Input placeholder="Enter Variant" />
            </Form.Item>
          ) : (
            <Form.Item
              label={attributeOptions.find(option => option.value === selectedAttribute)?.label || 'Value'}
              name="val"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          )
        }}
      </Form.Item>


    </Form >
  );
};

export default FeatureFlagForm;